import { CountUp } from 'countup.js';

export default {
	footer : null,
	triggered: false,
	init: function(){
		this.footer =  document.querySelector('#page-footer');

		window.addEventListener('scroll', this.triggerCount.bind(this), { passive: true });
	},
	triggerCount : function(ev){
		if (this.triggered === true){
			return false;
		}

		if(this.footer !== null){
			let bounds = this.footer.getBoundingClientRect();

			if(bounds.y < (window.outerHeight / 2)){
				this.footer.querySelectorAll('[data-number]').forEach(el => {
					el.count = new CountUp(el, el.dataset.number, {
						duration: 3
					});
					el.count.start();
				});

				this.triggered = true;
			}
		}
	}
}